import React from "react";

function TermsConditon_Content() {
  return (
    <>
      <div className="container text-start mb-5">
        <p className="privacy-content">
          Welcome to{" "}
          <a
            href="/"
            className="text-decoration-none"
            style={{ color: "#00adef" }}
          >
            Hermon Solutions
          </a>
          . By accessing or using our website and services, you agree to be
          bound by these Terms and Conditions. These terms govern your access to
          and use of our services, including but not limited to web development,
          mobile app development, UI/UX design, cloud computing, DevOps
          services, IT consulting, and all other digital solutions we offer. If
          you do not agree with any part of these terms, you must not use our
          services or website.
        </p>
        <p className="privacy-content">
          These Terms and Conditions form a legally binding agreement between
          you (the “Client”, “User”, or “Customer”) and Hermon Solutions
          (“Company”, “we”, “our”, or “us”). We recommend you read these terms
          carefully before engaging our services or submitting any personal or
          business-related information.
        </p>
        <p className="privacy-content">
          Our services are tailored for businesses, professionals,
          organizations, and entrepreneurs who are looking for IT and software
          development solutions. We do not provide services to individuals below
          the legal age of majority unless represented by a registered business
          entity. All engagements, quotations, proposals, or agreements are
          assumed to be business-to-business (B2B) in nature. By submitting an
          inquiry through our website, email, phone call, or chat, you agree
          that Hermon Solutions may contact you regarding your project or
          service interest. This may include sending you emails, estimates,
          proposals, reminders, or marketing content related to our services.
          You may opt out at any time by following unsubscribe instructions or
          contacting our team.
        </p>
        <p className="privacy-content">
          All quotes, proposals, and timelines provided by Hermon Solutions are
          estimations based on the requirements shared by the client at the time
          of communication. These are subject to change if scope, features,
          integrations, or complexity is modified during development. Final
          pricing and timelines may vary based on change requests or delays in
          feedback from the client. Once a service contract, scope of work
          (SOW), or invoice is approved, the client agrees to pay the specified
          amount on the agreed schedule. Failure to pay on time may result in
          project delay, suspension of services, or legal action for recovery.
          We reserve the right to charge interest or late fees for delayed
          payments beyond the due date.
        </p>
        <p className="privacy-content">
          Clients are expected to provide all necessary content, branding
          materials, access credentials, and technical details required for
          successful project execution. Hermon Solutions will not be responsible
          for delays caused due to unavailability of content or information from
          the client’s side. All client-provided content is assumed to be
          licensed or owned by the client. All code, assets, and deliverables
          remain the property of Hermon Solutions until full payment is
          received. Upon full settlement, we transfer ownership of the final
          deliverables (excluding third-party licenses, tools, or proprietary
          frameworks). We reserve the right to reuse general-purpose code
          snippets, templates, or modules that are non-exclusive and not
          customized specifically for the client.
        </p>
        <p className="privacy-content">
          The client grants us a non-exclusive, royalty-free right to showcase
          completed projects in our portfolio, social media channels, case
          studies, or website unless explicitly requested otherwise in writing.
          We honor confidentiality and will not disclose sensitive project
          details such as pricing, backend architecture, or user data. During
          the course of development, Hermon Solutions may integrate third-party
          services, APIs, plugins, or software based on the requirements. The
          client is responsible for reviewing the license terms, costs, and
          risks associated with such third-party tools. We are not liable for
          any changes, failures, or limitations arising from third-party
          platforms.
        </p>
        <p className="privacy-content">
          Any custom development provided by Hermon Solutions is covered by a
          basic post-deployment support period, the duration of which will be
          specified in the project agreement. Post this period, any new
          requests, issues, or feature enhancements will be charged separately.
          We offer paid maintenance, upgrade, and AMC plans based on client
          needs. All client data shared with Hermon Solutions, including project
          specifications, server credentials, and marketing strategies, will be
          treated as confidential. We commit to not sharing this information
          with any outside party except our authorized staff, contractors, or
          service providers working on the same project under NDA.
        </p>
        <p className="privacy-content">
          You agree not to misuse our services or website for any illegal,
          fraudulent, unethical, or unauthorized activity. You may not
          distribute malware, attempt hacking, engage in phishing, or misuse
          Hermon Solutions' intellectual property. We reserve the right to deny
          service, suspend accounts, or take legal action if such activities are
          detected. All content, graphics, logos, code, and documentation
          provided by Hermon Solutions are protected by copyright and may not be
          copied, distributed, or reused without prior written permission.
          Unauthorized use of our intellectual property will result in legal
          consequences.
        </p>
        <p className="privacy-content">
          In no event shall Hermon Solutions be liable for direct, indirect,
          incidental, consequential, or punitive damages resulting from your use
          of our services, delays in delivery, third-party tool failures, or
          business losses. All services are provided on an “as-is” and
          “as-available” basis without warranties of any kind unless otherwise
          stated in writing. We reserve the right to modify these Terms and
          Conditions at any time without prior notice. The updated version will
          be posted on this page, and continued use of our website or services
          will signify your acceptance of the updated terms. If a dispute arises
          regarding a project or payment, we aim to resolve it through
          discussion, documentation review, or mutual agreement.
        </p>
        <p className="privacy-content">
          If any clause or portion of these Terms and Conditions is found to be
          invalid, unlawful, or unenforceable by a court of law, the remaining
          sections will remain in full force and effect. Any such unenforceable
          clause will be replaced by a valid provision that closely reflects the
          original intent. By using the services of Hermon Solutions or browsing
          our website, you acknowledge that you have read, understood, and
          agreed to all the terms stated above. If you have any questions or
          concerns about these Terms & Conditions, we encourage you to contact
          our legal or support team.
        </p>
      </div>
    </>
  );
}

export default TermsConditon_Content;
